import React, { createContext, useContext, useState } from "react";

enum MCountry {
  SELECT_COUNTRY = "",
  ALL = "ALL",
  MALAYSIA = "MALAYSIA",
  SRI_LANKA = "SRI_LANKA",
  BOSNIA = "BOSNIA",
  JAMAICA = "JAMAICA",
  INDIA = "INDIA",
  INDONESIA = "INDONESIA"
}

interface AnnouncementFilterAdmin {
  date: Date | undefined;
  keyword: string;
  status: "active" | "inactive" | "default";
  country: MCountry;
}
const initialAnnouncemnetFiltersAdmin: AnnouncementFilterAdmin = {
  date: undefined,
  keyword: "",
  status: "default",
  country: MCountry.SELECT_COUNTRY,
};

interface AnnouncementFilterMember {
  date: Date | undefined;
  keyword: string;
  status: "active" | "inactive" | "default";
}
const initialAnnouncemnetFiltersMember: AnnouncementFilterMember = {
  date: undefined,
  keyword: "",
  status: "default",
};

export interface IAppContext {
  announcementFiltersAdmin: AnnouncementFilterAdmin;
  setAnnouncementFiltersAdmin: (filters: AnnouncementFilterAdmin) => void;
  announcementFiltersMember: AnnouncementFilterMember;
  setAnnouncementFiltersMember: (filters: AnnouncementFilterMember) => void;
}

interface IState {
  announcementFiltersAdmin: AnnouncementFilterAdmin;
  announcementFiltersMember: AnnouncementFilterMember;
}

const initialContext: IAppContext = {
  announcementFiltersAdmin: initialAnnouncemnetFiltersAdmin,
  setAnnouncementFiltersAdmin: (filters: AnnouncementFilterAdmin) => {},
  announcementFiltersMember: initialAnnouncemnetFiltersMember,
  setAnnouncementFiltersMember: (filters: AnnouncementFilterMember) => {},
};

const initialState: IState = {
  announcementFiltersAdmin: initialAnnouncemnetFiltersAdmin,
  announcementFiltersMember: initialAnnouncemnetFiltersMember,
};

const GlobelFilterContext = createContext<IAppContext>(initialContext);

interface IProps {
  children: any;
}

export const GlobelFilterProvider = (props: IProps) => {
  const [state, setState] = useState(initialState);

  const setAnnouncementFiltersAdmin = (filters: AnnouncementFilterAdmin) => {
    setState((ps) => {
      ps.announcementFiltersAdmin = filters;
      return { ...ps };
    });
  };

  const setAnnouncementFiltersMember = (filters: AnnouncementFilterMember) => {
    setState((ps) => {
      ps.announcementFiltersMember = filters;
      return { ...ps };
    });
  };

  return (
    <GlobelFilterContext.Provider
      value={{
        ...state,
        setAnnouncementFiltersAdmin,
        setAnnouncementFiltersMember,
      }}
    >
      {props.children}
    </GlobelFilterContext.Provider>
  );
};

export const useGlobelFilterContext = (): IAppContext =>
  useContext(GlobelFilterContext);
